module.exports = __webpack_public_path__ + "img/banner.01226fd4.jpg";